import { createFileRoute, Link } from '@tanstack/react-router';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PageHero } from '@/components/layout/PageHero';
import { CompaniesTable } from '@/features/customer/components/CompaniesTable';
import { useCompanies } from '@/features/customer/hooks';
import { companyDtoToRow } from '@/features/customer/company-data';
import { TableSkeleton } from '@/components/TableSkeleton';

/**
 * Customer Account — list of companies.
 *
 * A table of companies + "Create New Company". Each company = shared base
 * profile + a regulatory module per target market. Backed by /api/companies.
 */
export const Route = createFileRoute('/customer-account')({
  component: CustomerAccountListPage,
});

function CustomerAccountListPage() {
  const companiesQuery = useCompanies();
  const rows = (companiesQuery.data ?? []).map(companyDtoToRow);

  return (
    <>
      <PageHero
        title="Company Account"
        subtitle="Every company you've registered. Each carries its shared profile plus the regulatory module for every market it sells into."
      />
      <main className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-10 pt-8 pb-20 space-y-5">
        {companiesQuery.isLoading ? (
          <TableSkeleton rows={3} label="Loading companies" />
        ) : rows.length === 0 ? (
          <div className="bg-white border border-line rounded-2xl p-12 text-center shadow-card">
            <p className="text-muted mb-4">
              No companies yet — create your first to get started.
            </p>
            <Button asChild variant="brand">
              <Link to="/customer-account/new">
                <Plus className="size-4" /> Create New Company
              </Link>
            </Button>
          </div>
        ) : (
          <CompaniesTable rows={rows} />
        )}
      </main>
    </>
  );
}
